import wx from 'weixin-js-sdk'
import $http from './http'
let shareService = {};
shareService.isWeixin = function () {
  //判断是否是微信
  var ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == "micromessenger";
};
//首次登录获jssdk 第二次则不再获取
shareService.keys= false;

shareService.ready =($data)=>{
  
  if(!shareService.isWeixin()){
    return ;
  }
  if(!shareService.keys){
    $http.get("/Index/Wechat/jssdk")
    .then(function (res) {
      wx.config({
        debug: res.debug || false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, //公众号的唯一标识
        timestamp: res.timestamp, //生成签名的时间戳
        nonceStr: res.nonceStr, //生成签名的随机串
        signature: res.signature, //签名
        jsApiList: res.jsApiList
      });
      shareService.readyShare($data);
    });
  }else{
    shareService.readyShare($data);
  }
    
}
shareService.readyShare = ($data)=>{
 shareService.keys= true;
 let  title = $data.title || '';
 let  link = $data.url || location.href.split('#')[0];
 let  imgUrl = $data.icon || '';
 let  descp = $data.descp || '';
//  console.log($data.link,location.href);
 
    wx.ready(function () {
      wx.onMenuShareAppMessage({
        title: title,
        link: link,
        desc: descp,
        imgUrl: imgUrl,
      });
      wx.onMenuShareTimeline({
        title: title,
        link: link,
        desc: descp,
        imgUrl: imgUrl,
      });
      wx.onMenuShareQQ({
        title: title,
        link: link,
        desc: descp,
        imgUrl: imgUrl,
      });
      wx.onMenuShareWeibo({
        title: title,
        link: link,
        desc: descp,
        imgUrl: imgUrl,
      });
      wx.onMenuShareQZone({
        title: title,
        link: link,
        desc: descp,
        imgUrl: imgUrl,
      });
    });
}
shareService.config = () => {
  if (shareService.isWeixin) {
    $http.get("/Index/Wechat/jssdk")
      .then(function (res) {
        wx.config({
          debug: res.debug || false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, //公众号的唯一标识
          timestamp: res.timestamp, //生成签名的时间戳
          nonceStr: res.nonceStr, //生成签名的随机串
          signature: res.signature, //签名
          jsApiList: res.jsApiList
        });
      });
  }
}
// shareService.config();
export default shareService
